import { LogoMark } from "./Logo";

/**
 * WAITING, WITH THE MARK ON IT.
 *
 * Four screens had grown their own answer to the same moment: a pulsing grey
 * skeleton on one, the bare sentence "Loading the roster." on two more, and
 * "Reading the ledger." on the fourth. A skeleton promises a shape, which is a
 * promise this console cannot keep: the panels it draws depend on what the
 * query returns, so the grey blocks were rarely the shape that arrived.
 *
 * A mark and a ring say the honest thing instead, which is only that the
 * console is working. The label says what it is waiting for.
 *
 * IT HOLDS A SCREEN OF HEIGHT. Measured, Payments went from 702px waiting to
 * 4240px settled, so the page grew by five screens under the reader at the
 * instant the data landed. A minimum height cannot match an unknown payload,
 * but it stops the first screenful from jumping.
 */
export function Loading({ what }: { readonly what: string }) {
  return (
    <div
      className="flex min-h-[60vh] flex-col items-center justify-center gap-space-md py-space-xl"
      role="status"
      aria-live="polite"
    >
      <div className="relative flex h-16 w-16 items-center justify-center">
        {/* The ring. `motion-reduce` stops it for anybody who asked for that,
            and the mark underneath still says which product is thinking. */}
        <span
          aria-hidden="true"
          className="absolute inset-0 rounded-full border-2 border-outline-variant border-t-primary animate-spin motion-reduce:animate-none"
        />
        <LogoMark className="h-9 w-9 rounded-lg shadow-sm" />
      </div>
      <span className="font-body-sm text-body-sm text-on-surface-variant">{what}</span>
    </div>
  );
}
